import { BehaviorType } from "../types";
import Behavior from "../types/Behavior";
class KeystrokeSpeedBehavior extends Behavior {
    constructor(plasm, appName, addMetadata) {
        super(plasm, appName, addMetadata);
        this.collectIntervalDuration = 10000;
        this.keystrokesCount = 0;
        this.lastIntervalRunTime = Date.now();
        this.collectInterval = null;
        this.id = BehaviorType.keystrokespeed;
        this.handler = () => { };
        this.init();
        this.iframeBehaviorListeners = [{ type: "keydown", listener: this.keydownHandler }];
    }
    onKeydown() {
        this.keystrokesCount += 1;
    }
    init() {
        const keydownEvent = new Event("keydown");
        this.keydownHandler = () => this.onKeydown();
        this.collectInterval = setInterval(() => {
            const intervalRunTime = Date.now();
            const keystrokeSpeedMetadata = {
                fromTime: new Date(this.lastIntervalRunTime).toISOString(),
                toTime: new Date(intervalRunTime).toISOString(),
                keystrokesCount: this.keystrokesCount,
            };
            this.addLog(keydownEvent, this.id, keystrokeSpeedMetadata);
            this.keystrokesCount = 0;
            this.lastIntervalRunTime = intervalRunTime;
        }, this.collectIntervalDuration);
    }
    start() {
        window.addEventListener("keydown", this.keydownHandler);
        this.plasm.debug(`Behavior ${this.id} started`);
    }
    stop() {
        window.removeEventListener("keydown", this.keydownHandler);
        if (this.collectInterval != null) {
            clearInterval(this.collectInterval);
        }
        this.plasm.debug(`Behavior ${this.id} stopped`);
    }
}
export default KeystrokeSpeedBehavior;
